import { isAnalyticsCapturing } from "@/lib/analytics";
import { emailArrival, readEmailTouch, storeEmailTouch, validEmailTouch, type EmailTouch } from "@/lib/email-attribution";

let pending: EmailTouch | null = null;
function stored(): EmailTouch | null {
  try { return readEmailTouch(sessionStorage); } catch { return null; }
}
function remember(value: EmailTouch | null): void {
  pending = value;
  try { storeEmailTouch(sessionStorage, value); } catch { /* Storage is optional. */ }
}

/** Called from the earliest common entry, before Meta/PostHog and URL rewrites. */
export function captureEmailAttribution(): void {
  const privateRoute = /^\/(?:email-studio|handover)(?:\/|$)/.test(window.location.pathname);
  const result = emailArrival(window.location.href, privateRoute ? null : pending ?? stored());
  if (result.hadToken) window.history.replaceState(window.history.state, "", `${result.url.pathname}${result.url.search}${result.url.hash}`);
  pending = privateRoute ? null : result.touch;
}

export function retainEmailAttribution(): void {
  try {
    const value = pending ?? stored();
    remember(isAnalyticsCapturing() && validEmailTouch(value) ? value : null);
  } catch { remember(null); }
}

/** This never sends tokens or email identities to analytics. Only the
 * authenticated checkout endpoint receives the opaque receipt for validation. */
export function emailCheckoutAttribution(): { emailLinkToken?: string } {
  retainEmailAttribution();
  return pending ? { emailLinkToken: pending.token } : {};
}
